module.exports = __webpack_public_path__ + "static/media/board-game.9eaf9752.svg";